export { default } from './IntroBlockHighlights'
